/** Render-safe string for AI/heuristic values that may be objects (e.g. line items). */
export function formatCiDisplayValue(value: unknown): string | null {
  if (value == null) return null;

  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed || null;
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }

  if (Array.isArray(value)) {
    const parts = value
      .map((item) => formatCiDisplayValue(item))
      .filter((item): item is string => Boolean(item));
    return parts.length > 0 ? parts.join("; ") : null;
  }

  if (typeof value === "object") {
    const obj = value as Record<string, unknown>;
    const description = formatCiDisplayValue(obj.description);
    const hsCode = formatCiDisplayValue(obj.hsCode);
    const quantity = formatCiDisplayValue(obj.quantity);
    const unit = formatCiDisplayValue(obj.unit);
    const unitPrice = formatCiDisplayValue(obj.unitPrice);
    const total = formatCiDisplayValue(obj.total);

    if (description || hsCode || quantity || unit || unitPrice || total) {
      const parts = [
        description,
        hsCode ? `HS ${hsCode}` : null,
        quantity ? `Qty ${quantity}${unit ? ` ${unit}` : ""}` : unit,
        unitPrice ? `@ ${unitPrice}` : null,
        total ? `Total ${total}` : null,
      ].filter((part): part is string => Boolean(part));
      return parts.length > 0 ? parts.join(" · ") : null;
    }

    const generic = Object.entries(obj)
      .map(([key, nested]) => {
        const formatted = formatCiDisplayValue(nested);
        return formatted ? `${key}: ${formatted}` : null;
      })
      .filter((part): part is string => Boolean(part));

    return generic.length > 0 ? generic.join(" · ") : null;
  }

  return String(value);
}
